import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable()
export class PlatformDetectionService {
  private readonly platform = inject(Platform);

  isMobile() {
    return this.platform.is('ios') || (this.platform.is('android') && !(this.platform.is('desktop') || this.platform.is('mobileweb')));
  }

  isAndroid() {
    return this.isMobile() && this.platform.is('android');
  }

  isIos() {
    return this.isMobile() && this.platform.is('ios');
  }

  isWebBrowser() {
    return !this.isMobile();
  }
}
